"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _filterInvalidDomProps = _interopRequireDefault(require("filter-invalid-dom-props"));

var _rebass = require("rebass");

var _mainLink = require("./mainLink.style");

var _MainTheme = require("../MainTheme");

var MainLink = function MainLink(_ref) {
  var children = _ref.children,
      to = _ref.to,
      target = _ref.target,
      other = _objectWithoutProperties(_ref, ["children", "to", "target"]);

  var _ref2 = (0, _react.useContext)(_MainTheme.LinkContext),
      Link = _ref2.link;

  var _ref3 = (0, _emotionTheming.useTheme)(),
      slug = _ref3.slug;

  if (!to) {
    return children;
  } // make sure that all Lions Creativity external links open in a new tab


  var appliedTarget = slug === 'lionsCreativity' && to.indexOf('/my-account') === -1 ? '_blank' : target; // dependency injection in case a platform is using a routing solution and the default <a> tag won't suffice

  if (Link) {
    var filteredProps = (0, _filterInvalidDomProps.default)(other);
    return /*#__PURE__*/_react.default.createElement(Link, Object.assign({
      to: to,
      target: appliedTarget
    }, filteredProps), children);
  }

  return /*#__PURE__*/_react.default.createElement(_rebass.Link, Object.assign({
    "data-test": "external-link",
    href: to,
    rel: "noopener"
  }, other, {
    target: appliedTarget
  }), children, appliedTarget && /*#__PURE__*/_react.default.createElement(_mainLink.ScreenReaderOnly, null, "(opens in a new tab)"));
};

MainLink.propTypes = {
  to: _propTypes.default.string,
  target: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
MainLink.defaultProps = {
  to: '',
  target: undefined,
  children: ''
};
var _default = MainLink;
exports.default = _default;